import { RouterView } from "vue-router";
// import { warehousingRouting }  from './warehousing/warehousing.routing'
// import { retreatRouting } from './retreat/retreat.routing'
// import { maintainInfoRouting } from './maintainInfo/maintainInfo.routing'
// import { reductionRouting } from './reduction/reduction.routing'
export const QuoteRouting = {
  path: "/quote",
  name: "quote",
  component: RouterView,
  meta: { title: "施工估价宝", icon: "asset" },
  children: [
    {
      path: "/quote/quote-list",
      name: "quote-list",
      meta: { title: "施工估价宝" },
      component: () =>
        import(/* webpackChunkName: "warehousing-list" */ "@/views/quote/quote-list/list.vue"),
    },
    // ...warehousingRouting,
    // ...retreatRouting,
    // ...maintainInfoRouting,
    // ...reductionRouting
  ],
};
